import { StoragePermissionDTOUpdateType } from '../../model/model';
import { SEEDDATA_ACCOUNT_ID_MIA, SEEDDATA_GROUP_TEAM_A_ID, SEEDDATA_GROUP_TEAM_X_ID } from './static-data';
export class SeedService {
    dbService;
    storageService;
    constructor(dbService, storageService) {
        this.dbService = dbService;
        this.storageService = storageService;
    }
    async doSeed() {
        try {
            await this.dbService.createCustomfield({
                id: 'customfield_10033',
                key: 'customfield_10033',
                name: 'demo1field',
                untranslatedName: 'demo1field',
                custom: true,
                orderable: true,
                navigable: true,
                searchable: true,
                clauseNames: ['cf[10033]', 'demo1field', 'demo1field[Dropdown]'],
                isLocked: false,
                schema: {
                    type: 'option',
                    custom: 'com.atlassian.jira.plugin.system.customfieldtypes:cascadingselect',
                    customId: 10033,
                },
            }, [
                {
                    id: '10025',
                    name: 'Bug fields context',
                    description: 'A context used to define the custom field options for bugs.',
                    isGlobalContext: true,
                    isAnyIssueType: false,
                },
                {
                    id: '10026',
                    name: 'Task fields context',
                    description: 'A context used to define the custom field options for tasks.',
                    isGlobalContext: false,
                    isAnyIssueType: false,
                },
            ]);
            await this.storageService.patchUserPermissions({
                userAccountId: SEEDDATA_ACCOUNT_ID_MIA,
                permission: {
                    fieldId: 'customfield_10033',
                    contextId: null,
                },
                type: StoragePermissionDTOUpdateType.ADD,
            });
            await this.storageService.patchUserPermissions({
                userAccountId: SEEDDATA_ACCOUNT_ID_MIA,
                permission: {
                    fieldId: 'customfield_10033',
                    contextId: 11111, // DOES NOT EXIST
                },
                type: StoragePermissionDTOUpdateType.ADD,
            });
            await this.storageService.patchGroupPermissions({
                groupId: SEEDDATA_GROUP_TEAM_A_ID,
                permission: {
                    fieldId: 'customfield_10033',
                    contextId: null,
                },
                type: StoragePermissionDTOUpdateType.ADD,
            });
            await this.dbService.createCustomfieldContextOption('customfield_10033', '10025', 9501, 'foo', false);
            await this.dbService.createCustomfieldContextOption('customfield_10033', '10025', 9502, 'foobar', false);
            await this.dbService.createCustomfieldContextOption('customfield_10033', '10025', 9503, 'foorab', false);
            const bulkOptionsToCreate = [];
            for (let i = 1; i < 50; i++) {
                // child option
                bulkOptionsToCreate.push({ id: 9503 + i, optionId: 9503, value: 'foobar ' + i, disabled: false });
            }
            for (let i = 1; i < 5000; i++) {
                // further parent options
                bulkOptionsToCreate.push({ id: 9503 + i, optionId: undefined, value: 'foobar ' + i, disabled: false });
            }
            await this.dbService.createCustomfieldContextOptionsBulk('customfield_10033', '10025', bulkOptionsToCreate);
            await this.dbService.createCustomfieldContextOption('customfield_10033', '10026', 2601, 'foo2', false);
            await this.dbService.createCustomfieldContextOption('customfield_10033', '10026', 2602, 'foobar2', false);
            await this.dbService.createCustomfieldContextOption('customfield_10033', '10026', 2603, 'foorab2', false);
            await this.dbService.createCustomfield({
                id: 'customfield_10044',
                key: 'customfield_10044',
                name: 'demo2field',
                untranslatedName: 'demo2field',
                custom: true,
                orderable: true,
                navigable: true,
                searchable: true,
                clauseNames: ['cf[10044]', 'demo2field', 'demo2field[Dropdown]'],
                isLocked: false,
                schema: {
                    type: 'option',
                    custom: 'com.atlassian.jira.plugin.system.customfieldtypes:select',
                    customId: 10044,
                },
            }, [
                {
                    id: '10041',
                    name: 'Bug fields context Foo',
                    description: 'A context used to define the custom field options for bugs.',
                    isGlobalContext: true,
                    isAnyIssueType: false,
                },
                {
                    id: '10042',
                    name: 'Task fields context Bar',
                    description: 'A context used to define the custom field options for tasks.',
                    isGlobalContext: false,
                    isAnyIssueType: false,
                },
            ]);
            await this.storageService.patchGroupPermissions({
                groupId: SEEDDATA_GROUP_TEAM_X_ID,
                permission: {
                    fieldId: 'customfield_10044',
                    contextId: 10041,
                },
                type: StoragePermissionDTOUpdateType.ADD,
            });
            await this.dbService.createCustomfieldContextOption('customfield_10044', '10041', 4101, 'foo3', false);
            await this.dbService.createCustomfieldContextOption('customfield_10044', '10041', 4102, 'foobar3', false);
            await this.dbService.createCustomfieldContextOption('customfield_10044', '10041', 4103, 'foorab3', false);
            await this.dbService.createCustomfieldContextOption('customfield_10044', '10042', 4201, 'foo4', false);
            await this.dbService.createCustomfieldContextOption('customfield_10044', '10042', 4202, 'foobar4', false);
            await this.dbService.createCustomfieldContextOption('customfield_10044', '10042', 4203, 'foorab4', false);
            await this.dbService.createCustomfield({
                id: 'fixVersions',
                key: 'fixVersions',
                name: 'Fix versions',
                custom: false,
                orderable: true,
                navigable: true,
                searchable: true,
                clauseNames: ['fixVersion'],
                isLocked: false,
                schema: {
                    type: 'array',
                    items: 'version',
                    system: 'fixVersions',
                },
            }, []);
            await this.dbService.createCustomfield({
                id: 'customfield_10066',
                key: 'customfield_10066',
                name: 'demo3fieldLocked',
                untranslatedName: 'demo3fieldLocked',
                custom: true,
                orderable: true,
                navigable: true,
                searchable: true,
                clauseNames: ['cf[10066]', 'demo3fieldLocked', 'demo3fieldLocked[Dropdown]'],
                isLocked: true,
                schema: {
                    type: 'option',
                    custom: 'com.atlassian.jira.plugin.system.customfieldtypes:select',
                    customId: 10066,
                },
            }, [
                {
                    id: '10061',
                    name: 'Bug fields context Foo',
                    description: 'A context used to define the custom field options for bugs.',
                    isGlobalContext: true,
                    isAnyIssueType: true,
                },
            ]);
            await this.storageService.patchUserPermissions({
                userAccountId: SEEDDATA_ACCOUNT_ID_MIA,
                permission: {
                    fieldId: 'customfield_10066',
                    contextId: null,
                },
                type: StoragePermissionDTOUpdateType.ADD,
            });
            await this.dbService.createCustomfieldContextOption('customfield_10066', '10061', 6101, 'foo4', false);
            await this.dbService.createCustomfieldContextOption('customfield_10066', '10061', 6102, 'foobar4', false);
            await this.dbService.createCustomfieldContextOption('customfield_10066', '10061', 6103, 'foorab4', false);
            await this.dbService.createCustomfield({
                id: 'customfield_10099',
                key: 'customfield_10099',
                name: 'Category',
                untranslatedName: 'Category',
                custom: true,
                orderable: true,
                navigable: true,
                searchable: true,
                clauseNames: ['cf[10099]', 'Category', 'Category[Dropdown]'],
                isLocked: false,
                schema: {
                    type: 'option',
                    custom: 'com.atlassian.jira.plugin.system.customfieldtypes:jwm-category',
                    customId: 10099,
                },
            }, [
                {
                    id: '10099',
                    name: 'Foo fields context Category',
                    description: 'A context used to define the custom field options for Category.',
                    isGlobalContext: true,
                    isAnyIssueType: true,
                },
            ]);
            for (let i = 0; i < 100; i++) {
                const id = 13000 + i;
                const contextId = 400 + i;
                await this.dbService.createCustomfield({
                    id: `customfield_${id}`,
                    key: `customfield_${id}`,
                    name: `oneOfMany${id}`,
                    untranslatedName: `oneOfMany${id}`,
                    custom: true,
                    orderable: true,
                    navigable: true,
                    searchable: true,
                    clauseNames: [`cf[${id}]`, `oneOfMany${id}`, `oneOfMany${id}[Dropdown]`],
                    isLocked: false,
                    schema: {
                        type: 'option',
                        custom: 'com.atlassian.jira.plugin.system.customfieldtypes:select',
                        customId: id,
                    },
                }, [
                    {
                        id: `${contextId}`,
                        name: `Default Context ${contextId}`,
                        description: 'bla.',
                        isGlobalContext: true,
                        isAnyIssueType: true,
                    },
                ]);
            }
            const contexts = [];
            for (let i = 700; i < 900; i++) {
                contexts.push({
                    id: `${i + 1}`,
                    name: `ManyContext 700er Context ${i + 1}`,
                    description: 'bla',
                    isGlobalContext: true,
                    isAnyIssueType: true,
                });
            }
            await this.dbService.createCustomfield({
                id: `customfield_10777`,
                key: `customfield_10777`,
                name: `has200Contexts`,
                untranslatedName: `has200Contexts`,
                custom: true,
                orderable: true,
                navigable: true,
                searchable: true,
                clauseNames: [`cf[10777]`, `has200Contexts`, `has200Contexts[Dropdown]`],
                isLocked: false,
                schema: {
                    type: 'option',
                    custom: 'com.atlassian.jira.plugin.system.customfieldtypes:select',
                    customId: 10777,
                },
            }, contexts);
            //
            // CREATE 100 Customfields for Pagination
            //
            for (let i = 900; i < 1000; i++) {
                const contextsInner = [];
                contextsInner.push({
                    id: `11${i}`,
                    name: `VieleFelder 9er Context 11${i}`,
                    description: 'bla',
                    isGlobalContext: true,
                    isAnyIssueType: true,
                });
                await this.dbService.createCustomfield({
                    id: `customfield_10${i}`,
                    key: `customfield_10${i}`,
                    name: `Field 9er ${i}`,
                    untranslatedName: `Field 9er ${i}`,
                    custom: true,
                    orderable: true,
                    navigable: true,
                    searchable: true,
                    clauseNames: [`cf[10${i}]`, `Field 9er ${i}`, `Field 9er ${i}[Dropdown]`],
                    isLocked: false,
                    schema: {
                        type: 'option',
                        custom: 'com.atlassian.jira.plugin.system.customfieldtypes:select',
                        customId: parseInt(`10${i}`, 10),
                    },
                }, contextsInner);
            }
        }
        catch (err) {
            console.log('seed error', err);
        }
    }
}
